import { useEffect } from 'react'
import {
	APPLICATION_DOCUMENTS_MAX,
	countRequirements,
} from '../../../constants/applicationDocumentCatalog'
import { applicationDocumentsStore } from '../../../model/applicationDocumentsStore'

export const useDocuments = application => {
	const studentId = application?.studentId

	useEffect(() => {
		if (!studentId) return
		void applicationDocumentsStore.load(studentId)
	}, [studentId])

	const groups = applicationDocumentsStore.groups
	const isLoading = applicationDocumentsStore.isLoading

	const flatItems = groups.flatMap(group => group.items || [])

	// Counted by requirement, not by row: a requirement can render several rows
	// (one per uploaded file), and two files against one requirement is still one
	// requirement satisfied.
	const satisfied = new Set(
		flatItems
			.filter(item => item.counselorStatus === 'success' && item.requirementId)
			.map(item => item.requirementId),
	)
	// The denominator comes from what the API actually asked this student for.
	// It is no longer a constant - a student who applied to a course needing a
	// financial affidavit owes more documents than one who did not.
	const total = countRequirements(groups) || APPLICATION_DOCUMENTS_MAX
	const uploadedCount = satisfied.size
	const progress = Math.min(100, Math.round((uploadedCount / total) * 100))

	return {
		isLoading,
		groups,
		progress,
		uploadedCount,
		total,
		reload: () => applicationDocumentsStore.reload(),
	}
}
